<template>
  <div class="count-down-wrapper" v-if="showCountDown || showApplyBtn">
    <div class="count-down-bg-container">
      <img :src="bgImg" alt="" />
    </div>
    <template v-if="showCountDown && !isStart">
      <div class="title-text">距离大会开幕还有</div>
      <div class="time">
        <div class="part">
          <template v-if="remainTime.dd.length > 2">
            <div class="box">{{ remainTime.dd.slice(0, 1) }}</div>
            <div class="box">{{ remainTime.dd.slice(1, 2) }}</div>
            <div class="box">{{ remainTime.dd.slice(2) }}</div>
          </template>
          <template v-else>
            <div class="box">{{ remainTime.dd.slice(0, 1) }}</div>
            <div class="box">{{ remainTime.dd.slice(1) }}</div>
          </template>
          <div class="text">天</div>
        </div>
        <div class="part">
          <div class="box">{{ remainTime.hh.slice(0, 1) }}</div>
          <div class="box">{{ remainTime.hh.slice(1) }}</div>
          <div class="text">时</div>
        </div>
        <div class="part">
          <div class="box">{{ remainTime.mm.slice(0, 1) }}</div>
          <div class="box">{{ remainTime.mm.slice(1) }}</div>
          <div class="text">分</div>
        </div>
        <div class="part">
          <div class="box">{{ remainTime.ss.slice(0, 1) }}</div>
          <div class="box">{{ remainTime.ss.slice(1) }}</div>
          <div class="text">秒</div>
        </div>
      </div>
    </template>
    <template v-else-if="showCountDown && isStart">
      <div class="title-text-open title-text">大会已盛大开幕，欢迎参会！</div>
    </template>
    <div class="btn-block" @click="handleClick" v-if="showApplyBtn">
      参会报名
    </div>
    <!-- 新版登录框 -->
    <LoginModal ref="LoginModalRef" @loginSuccess="onLoginSuccess" />
  </div>
</template>
<script setup>
import { ref, computed } from "vue";
import store from "@/store";
import { useRouter } from "vue-router";
import { useReaminTime } from "@/hooks/useRemainTime";
import defaultBg from "@/assets/pc/count-down-bg.png";
import LoginModal from "./LoginModal.vue";

const LoginModalRef = ref(null);
const router = useRouter();
const handleClick = () => {
  const token = localStorage.getItem("token");
  // 未登录，需要先登录
  if (!token) {
    // store.commit("user/setPcLoginPop", true);
    LoginModalRef.value.showModal();
    return;
  }
  router.push({ name: "My" });
};

const remainTime = useReaminTime(store.getters["config/getConfig"].startTime);

const isStart = computed(() => {
  const now = Date.now();
  const start = new Date(store.getters["config/getConfig"].startTime).getTime();

  return now > start;
});

const showApplyBtn = computed(() => {
  return !!store.getters["config/getConfig"].indexActivityButton;
});

const showCountDown = computed(() => {
  return !!store.getters["config/getConfig"].indexCountdownButton;
});

const bgImg = computed(
  () => store.getters["config/getConfig"].pcBackgroundImage || defaultBg
);

const onLoginSuccess = () => {
  router.push({ name: "My" });
};
</script>
<style lang="less" scoped>
.count-down-wrapper {
  height: 204px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 0 20px;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  .count-down-bg-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all linear;
    z-index: -1;
    img {
      transition: width 2s;
      display: block;
      width: 0;
      height: 0;
      min-width: 100%;
      max-width: 100%;
      min-height: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
}

.title-text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #fff;
  line-height: 22px;
  text-align: center;
}
.time {
  padding: 24px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 16px;
  .part {
    display: flex;
    align-items: center;
    justify-content: center;
    .box {
      width: 37px;
      height: 49px;
      background: url(./../../assets/pc/count-down-item.png) no-repeat 0 0;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: Arial, Arial;
      font-weight: 900;
      font-size: 32px;
      color: #fff;
    }
    .box + .box {
      margin-left: 4px;
    }
    .text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #fff;
      margin-left: 10px;
    }
  }
}
.title-text-open {
  height: 124px;
  display: flex;
  align-items: center;
}
.btn-block {
  width: 698px;
  height: 40px;
  background: @theme-color;
  border-radius: 4px;
  text-align: center;
  line-height: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
</style>
